<template>

    <ui-table-row class="ui-table-header" v-bind="$componentProps('ui-table-row')">
        <slot></slot>
    </ui-table-row>

</template>

<script lang="ts">

import { Component, Vue } from 'vue-facing-decorator';

import type { ComponentProps } from '@wittignl/js-core';
import { componentPropsMixin, createComponentMixin } from '@wittignl/js-core';

import type { TableRowProps } from './TableRow.vue';
import TableRow, { tableRowCompMixin } from './TableRow.vue';

@Component({
    name: 'ui-table-header',
    components: {
        'ui-table-row': TableRow
    },
    mixins: [componentPropsMixin, tableRowCompMixin]
})
export default class TableHeader extends Vue {}

export type TableHeaderComp = InstanceType<typeof TableHeader>
export type TableHeaderProps = ComponentProps<TableHeaderComp> & TableRowProps
export const tableHeaderCompMixin = createComponentMixin(TableHeader, tableRowCompMixin)

</script>
<style src="../../../scss/component/table/TableHeader.scss" lang="scss"></style>